import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.$props.list && _ctx.$props.list.length > 0)
    ? (_openBlock(), _createElementBlock("ul", {
        key: 0,
        ref: "slider",
        class: _normalizeClass(["text_slider", [{ animate: $setup.isAnimate }, { revers: $props.isReverse }, { vertical: $props.isVertical }]]),
        style: _normalizeStyle({ animationDuration: $setup.duration + 's' })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (content, idx) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `origin_${idx}`
          }, [
            _createElementVNode("p", null, _toDisplayString(content), 1)
          ]))
        }), 128)),
        ($setup.isAnimate)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.list, (content, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `clone_${idx}`
              }, [
                _createElementVNode("p", null, _toDisplayString(content), 1)
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ], 6))
    : _createCommentVNode("", true)
}